// TEST-only tools fail closed until the backend confirms the environment.
export function testToolsVisible(environment?: string): boolean {
  return environment === "test";
}
